import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import List from "../pages/list/page";
import MangaDetail from "../pages/manga/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/list",
    element: <List />,
  },
  {
    path: "/manga/:id",
    element: <MangaDetail />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;